import { CustomerPortalContactUpdateRequest } from '@monetize/types/app';
import { ReactNode } from 'react';
import { Controller, UseFormReturn } from 'react-hook-form';
import { MCheckbox } from '../../../../../components/Monetize';

interface ContactsCardBodyUseShippingAsBillingProps {
  formState: UseFormReturn<CustomerPortalContactUpdateRequest>;
  isDisabled?: boolean;
  children: ReactNode;
}

export const ContactsCardBodyUseShippingAsBilling = ({
  formState,
  isDisabled = false,
  children,
}: ContactsCardBodyUseShippingAsBillingProps) => {
  const { control, watch } = formState;

  const useSameShippingBilling = watch('useSameShippingBilling');

  return (
    <>
      <Controller
        control={control}
        name="useSameShippingBilling"
        render={({ field: { value, ...rest } }) => (
          <MCheckbox isChecked={value} {...rest} isDisabled={isDisabled}>
            Same as Bill To Contact
          </MCheckbox>
        )}
      />
      {!useSameShippingBilling && children}
    </>
  );
};
